import { render, staticRenderFns } from "./headers.vue?vue&type=template&id=1efb2e4d&scoped=true&"
import script from "./headers.vue?vue&type=script&lang=js&"
export * from "./headers.vue?vue&type=script&lang=js&"
import style0 from "./headers.vue?vue&type=style&index=0&id=1efb2e4d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efb2e4d",
  null
  
)

export default component.exports